/**
 * @generated SignedSource<<9102907891884f4cf549e6386bc2cd0a>>
 * @relayHash 00440bbe51c0e32bdc5d206bddc550e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e9be00f2b4dd73c26321f514b801a60fb1db78572af8b4419e03240610932204

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ServiceHubDetailsPageQuery } from './ServiceHubDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<ServiceHubDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e9be00f2b4dd73c26321f514b801a60fb1db78572af8b4419e03240610932204",
    "metadata": {},
    "name": "ServiceHubDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
